<template>
  <div class="">
    <q-card flat bordered class="row q-my-sm q-py-xs">
      <FilterSignals
        v-if="(buyData || sellData) && allStocks"
        :isMySignal="isMySignal"
        :isStockProfile="isStockProfile"
        :stockSymbol="stockSymbol"
        :buyData="buyData"
        :sellData="sellData"
        :buttonBuyOrSell="buttonBuyOrSell"
        :indicatorsSymbols="indicatorsSymbols"
        :indicatorsDate="indicatorsDate"
        :indicatorsValue="indicatorsValue"
        :isStatusVALID="isStatusValid"
        :filterList="[
          'stocks',
          'mySignals',
          'volume',
          'sectors',
          'riskReward',
          'validInvalid',
        ]"
        @filteredData="(e) => (finalComputedData = e)"
      />
    </q-card>

    <ListCard
      class="q-mb-md"
      :name="'Green Signal'"
      cv
      :data="finalComputedData"
      :noHeader="true"
      :weekly="true"
      :type="'buy_confirm'"
      :loading="loading"
      :intraday="timePeriod == 'hourly' ? true : false"
      :activeSymbol="selectedSymbol || finalComputedData[0]?.symbol"
      :activeDate="selectedDate || finalComputedData[0]?.date"
      @clickSymbolandDate="
        (eventSymbol, eventDate) => {
          selectedSymbol = eventSymbol;
          selectedDate = eventDate;
        }
      "
    />


    <q-card>
      <DisclaimerMessage class="q-mt-xs" short />
    </q-card>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import useMembership from "src/use/membership";

import ListCard from "src/components/ListCardCopy.vue";
import DisclaimerMessage from "src/components/DisclaimerMessage.vue";
import FilterSignals from "../filterSignals/filterSignals.vue";

export default {
  name: "ListCardTableView",
  emits: ["selectedSymbol", "selectedSymbolDate", "EmitActiveInstance"],
  props: {
    isMySignal: {
      type: Boolean,
      default: false,
    },
    isStockProfile: {
      type: Boolean,
      default: false,
    },
    stockSymbol: {
      type: String,
      default: null,
    },
    filterAverageVolume: {
      type: Boolean,
      default: false,
    },
    filterIndicatorsMatch: {
      type: Boolean,
      default: false,
    },
    filterMySignals: {
      type: Boolean,
      default: false,
    },
    filterRiskReward: {
      type: Boolean,
      default: false,
    },
    filterSectorWise: {
      type: Boolean,
      default: false,
    },
    filterValidStatus: {
      type: Boolean,
      default: false,
    },
    buyData: { type: Array },
    sellData: { type: Array },
    buttonBuyOrSell: { type: String },
    alertOrSignal: {
      type: String,
    },
    timePeriod: {
      type: String,
    },
    tableTitle: {
      type: String,
    },
    isStatusValid: { type: Boolean, default: true },

    indicatorsSymbols: {
      type: Array,
      default() {
        return [];
      },
    },
    indicatorsDate: { type: String },
    indicatorsValue: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    ListCard,
    // StockwiseKeyValueComponents,
    DisclaimerMessage,
    FilterSignals,
  },

  setup(props, context) {
    const $route = useRoute();
    const store = useStore();
    const { getPackage, getPackageStatus } = useMembership();
    const mySignals = ref(false);
    const packageDetail = ref({});
    const myStockList = ref({});
    const finalComputedData = ref([]);

    let rsiOrMacd = ref("rsi");

    let tab = ref($route.query?.type || "divergence");

    const isExtraPermissions = ref(false);
    const isFeatureAvilable = ref(false);
    const packageDetailStatus = ref({});

    const loading = ref(true);

    let symbol = ref("");

    const searchedSymbol = ref(null);
    const riskReward = ref("All");
    const isValid = ref("All");

    let selectedSymbol = ref("");
    let selectedDate = ref(null);
    let volumeGreaterThenAvgVol = ref(false);

    getPackageStatus().then((res) => {
      packageDetailStatus.value = res.data;
      isExtraPermissions.value =
        res.data?.extra_permissions?.includes("DIVERGENCE_SIGNAL") || false;

      isFeatureAvilable.value =
        res.data.current_package.features?.includes("is_divergence_signal") ||
        false;
    });

    const optionSectors = ref([
      {
        id: 0,
        symbol: "All Sectors",
        name: "All Sectors",
        label: "All Sectors",
      },
      { id: 1, symbol: "BANKING", name: "Banking" },
      { id: 2, symbol: "DEVBANK", name: "Dev Banks" },
      { id: 3, symbol: "FINANCE", name: "Finance" },
      { id: 4, symbol: "HOTELS", name: "Hotels" },
      { id: 5, symbol: "HYDRO", name: "Hydropower" },
      { id: 6, symbol: "INVESTMENT", name: "Investment" },
      { id: 7, symbol: "LIFEINSU", name: "Life Insurance" },
      { id: 8, symbol: "MANUFACTURE", name: "Manufacturing" },
      { id: 9, symbol: "MICROFINANCE", name: "Microfinance" },
      { id: 10, symbol: "NONLIFEINSU", name: "NonLife" },
      { id: 11, symbol: "OTHERS", name: "Others" },
      { id: 12, symbol: "TRDIND", name: "Tradings" },
    ]);
    const selectedSector = ref(optionSectors.value[0]);
    const allStocks = ref([]);

    const bullishOrBearish = computed(() => {
      if (props.buttonBuyOrSell == "buy") {
        return "Bullish";
      } else {
        return "Bearish";
      }
    });

    store.dispatch("core/getAllStocks").then(() => {
      allStocks.value = store.state.core.allStocks;
    });

    if (store.state.authenticate.isAuthenticated) {
      getPackage()
        .then((res) => {
          packageDetail.value = res.data;
          myStockList.value = res.data.stocks;

          loading.value = false;
        })
        .catch((err) => {
          packageDetail.value = null;
        });
    }

    const activeInstance = computed(() => {
      if (props.buyData || props.SellData) {
        if (props.buttonBuyOrSell == "buy") {
          return props.buyData.find(
            (i) =>
              i.symbol == selectedSymbol.value && i.date === selectedDate.value
          );
        } else {
          return props.sellData.find(
            (i) =>
              i.symbol == selectedSymbol.value && i.date === selectedDate.value
          );
        }
      } else return [];
    });

    watch(finalComputedData, (newVal, oldVal) => {
      selectedSymbol.value = newVal[0]?.symbol;
      selectedDate.value = newVal[0]?.date;
      context.emit("selectedSymbol", selectedSymbol.value);
      context.emit("EmitActiveInstance", activeInstance.value);
    });
    

    watch(selectedSymbol, (newVal, oldVal) => {
      context.emit("selectedSymbol", selectedSymbol.value);
      context.emit("EmitActiveInstance", activeInstance.value);
      context.emit(
        "selectedSymbolDate",
        selectedSymbol.value,
        selectedDate.value
      );
    });
    watch(activeInstance, (newActiveInstance, oldActiveInstance) => {
      context.emit("EmitActiveInstance", newActiveInstance);
    });

    return {
      // testFuntion,
      rsiOrMacd,
      isExtraPermissions,
      isFeatureAvilable,
      packageDetailStatus,

      bullishOrBearish,
      volumeGreaterThenAvgVol,
      myStockList,
      allStocks,
      mySignals,

      selectedSymbol,
      selectedDate,
      activeInstance,

      symbol,

      packageDetail,
      loading,
      tab,

      selectedSector,
      optionSectors,

      riskReward,
      isValid,
      finalComputedData,
      searchedSymbol,
    };
  },
};
</script>
